module.exports = "<div class={%- classWidth %}> <div class=q-marg-vert-md-at-md> {%- date %} {% if (status === 'New') { %} <span class=\"q-pretty-pill-tag q-ppt-pad-md q-ppt-green q-ppt-large-radius q-fs-xs q-marg-left-md\">NEW</span> {% } %} </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/WidgetEngine/html/globalHtml/dateColTemplate.html
// module id = 1132
// module chunks = 1